export default "__VITE_ASSET__iXnXkPuI__"